import i18n from '../lang/i18n.js' // eslint-disable-line
import currencyCodes from '@/utils/currencyCodes.js'
// import Vue from 'vue'
class Utils {
  /**
    * @description: Validate email.
    * @param: string + @ + string
    * @returns: boolean
    **/
  static validateEmail (val) {
    const regxEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    return regxEmail.test(val)
  }

  /**
    * @description: Validate Nombre Apellidos.
    * @param: string + @ + string
    * @returns: boolean
    **/
  static validateCaracEspecial (val) {
    const regCarcEspecial = /[!¡?¿#(&)"@'`_|/+=*,;:%$<>ºª{}-]/
    return regCarcEspecial.test(val)
  }

  static getISOCode (val) {
    return currencyCodes[val]
  }
}

export { Utils }
